import { useContext, useEffect } from "react";
import { WeglotContext } from "@stadium/services/weglot/provider";

const WeglotWrapper = ({ children }) => {
  const { initialize, loaded } = useContext(WeglotContext);

  useEffect(() => {
    if (loaded) initialize();
  }, [initialize, loaded]);

  return children;
};

export default WeglotWrapper;
